import React, {useEffect, useState} from "react";
import {useGlobal} from "../../Store";
import Strings from "../../Constants/Strings";
import {postData} from "../../Utils/Server";
import Endpoints from "../../Constants/Endpoints";
import {handleUserAccess} from "../../Utils/Auth";
import {ERROR, Notify, SUCCESS} from "../../Utils/Notify";
import PageLayout from "../Layout/PageLayout";
import {Card, Tabs, FormField, TextInput, Button} from "../UI";

const Settings = props => {

    const [globalState, globalActions] = useGlobal();
    const [isLoading, setIsLoading] = useState(false);
    const [name, setName] = useState('');
    const [email, setEmailAddress] = useState('');
    const [password, setPassword] = useState('');
    const [confirmPassword, setConfirmPassword] = useState('');
    const [newPassword, setNewPassword] = useState('');

    const [settings, setSettings] = useState('');
    const [businessFee, setBusinessFee] = useState('');
    const [returnPerc, setReturnPerc] = useState('');

    const [tab, setTab] = useState('settings');

    useEffect(() => {
        document.title = "Settings | " + Strings.APP_DESCRIPTION;

        if (globalState.userLoggedIn) {
            setName(globalState.currentUser.name);
            setEmailAddress(globalState.currentUser.email);
        }

        loadSettings()

    }, [globalState.userLoggedIn]);

    const submitProfileForm = e => {
        e.preventDefault();

        if (name === '') {
            Notify("Name is required", ERROR);
            return;
        }

        if (!(!!email)) {
            Notify("Email is required", ERROR);
            return;
        }

        let data = new FormData();
        data.append("name", name)
        data.append("email", email)

        setIsLoading(true);

        postData(Endpoints.UPDATE_PROFILE, data)
            .then(res => res.json())
            .then(res => {
                setIsLoading(false);
                if (res.success === 1) {
                    Notify("Profile updated successfully", SUCCESS);
                    handleUserAccess(res, globalActions, false);
                } else {
                    if (Array.isArray(res.message)) {
                        Notify(res.message[0], ERROR);
                    } else {
                        Notify(res.message, ERROR);
                    }
                }
            })
            .catch((error) => {
                setIsLoading(false);
                console.log(error)
            });

    }

    const submitPasswordForm = e => {
        e.preventDefault();

        if (!(!!password)) {
            Notify("Current password is required", ERROR);
            return;
        }

        if (!(!!newPassword)) {
            Notify("New password is required", ERROR);
            return;
        }

        if (newPassword !== confirmPassword) {
            Notify("Please confirm your password", ERROR);
            return;
        }

        let data = new FormData();
        data.append("old_password", password)
        data.append("new_password", newPassword)

        setIsLoading(true);

        postData(Endpoints.UPDATE_PASSWORD, data)
            .then(res => res.json())
            .then(res => {
                setIsLoading(false);
                if (res.success === 1) {
                    Notify("Password updated successfully", SUCCESS);
                    handleUserAccess(res, globalActions, false);
                } else {
                    if (Array.isArray(res.message)) {
                        Notify(res.message[0], ERROR);
                    } else {
                        Notify(res.message, ERROR);
                    }
                }
            })
            .catch((error) => {
                setIsLoading(false);
                console.log(error)
            });

    }

    const submitSettings = e => {
        e.preventDefault();

        if (!(!!businessFee)) {
            Notify("Business fee is required", ERROR);
            return;
        }

        if (!(!!returnPerc)) {
            Notify("Return percentage is required", ERROR);
            return;
        }

        let data = new FormData();
        data.append("business_fee", businessFee)
        data.append("return_percentage", returnPerc)

        setIsLoading(true);

        postData(Endpoints.UPDATE_SETTINGS, data)
            .then(res => res.json())
            .then(res => {
                setIsLoading(false);
                if (res.success === 1) {
                    Notify("Site settings updated successfully", SUCCESS);
                } else {
                    if (Array.isArray(res.message)) {
                        Notify(res.message[0], ERROR);
                    } else {
                        Notify(res.message, ERROR);
                    }
                }
            })
            .catch((error) => {
                setIsLoading(false);
                console.log(error)
            });

    }

    function loadSettings() {
        let data = new FormData();

        setIsLoading(true)
        postData(Endpoints.LIST_SETTINGS, data)
            .then(res => res.json())
            .then(res => {
                setIsLoading(false);
                if (res.success === 1 && res.data.length > 0) {
                    setBusinessFee(res.data[0].business_fee);
                    setReturnPerc(res.data[0].return_percentage);
                }
            })
            .catch((error) => {
                setIsLoading(false);
                console.log(error)
            });
    }

    return (
        <PageLayout title="Settings">
            <Tabs
                tabs={[
                    {key: "settings", label: "General site settings"},
                    {key: "profile", label: "Update profile"},
                    {key: "password", label: "Change password"},
                ]}
                value={tab}
                onChange={setTab}
            />

            {tab === "settings" &&
            <Card style={{maxWidth: 640}}>
                <form>
                    <FormField label="Business registration fee">
                        <TextInput type="number"
                                   placeholder="Fee"
                                   value={businessFee}
                                   onChange={e => setBusinessFee(e.target.value)}
                        />
                    </FormField>

                    <Button type="submit" loading={isLoading} onClick={e => submitSettings(e)}>
                        Update site settings
                    </Button>
                </form>
            </Card>
            }

            {tab === "profile" &&
            <Card style={{maxWidth: 640}}>
                <form>
                    <FormField label="Name">
                        <TextInput type="text"
                                   placeholder="Title"
                                   value={name}
                                   onChange={e => setName(e.target.value)}
                        />
                    </FormField>

                    <FormField label="Email address">
                        <TextInput type="text"
                                   placeholder="Email address"
                                   value={email}
                                   onChange={e => setEmailAddress(e.target.value)}
                        />
                    </FormField>

                    <Button type="submit" loading={isLoading} onClick={e => submitProfileForm(e)}>
                        Update profile
                    </Button>
                </form>
            </Card>
            }

            {tab === "password" &&
            <Card style={{maxWidth: 640}}>
                <form>
                    <FormField label="Current password">
                        <TextInput type="password"
                                   placeholder="Current password"
                                   value={password}
                                   onChange={e => setPassword(e.target.value)}
                        />
                    </FormField>

                    <FormField label="New password">
                        <TextInput type="password"
                                   placeholder="New password"
                                   value={newPassword}
                                   onChange={e => setNewPassword(e.target.value)}
                        />
                    </FormField>

                    <FormField label="Confirm new password">
                        <TextInput type="password"
                                   placeholder="Confirm new password"
                                   value={confirmPassword}
                                   onChange={e => setConfirmPassword(e.target.value)}
                        />
                    </FormField>

                    <Button type="submit" loading={isLoading} onClick={e => submitPasswordForm(e)}>
                        Change password
                    </Button>
                </form>
            </Card>
            }
        </PageLayout>
    )
};

export default Settings;
